module.exports = __webpack_public_path__ + "static/PdPmockup2-56c6f40fb99c743e6d773134d205a492.jpg";